import styled from "styled-components";

export const Container = styled.div`
  padding: 3% 0;
`;
export const Row = styled.div``;
// export const Container = styled.div``
// export const Container = styled.div``
// export const Container = styled.div``
